import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getDieToolList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getDieToolListByDieId = (dieId, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/', {
        headers: authHeader(), params: {
            die: dieId,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};
const getToolListByProfileId = (id, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + `/die-tool/${id}/die-tool-by-profile/`, {
        headers: authHeader(), 
        params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};
const getDieArchiveToolList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool/archive-list', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getDieToolDetails = (dieId) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/die-tool-details/', {
        headers: authHeader(), params: {
            die: dieId
        }
    });
};


const getDieToolById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/die-tool/${id}/`, {
        headers: authHeader()
    });
};
const addDieTool = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-tool/`,
        formData, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const updateDieTool = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/die-tool/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};
const deleteDieTool = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-tool/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveDieToolRecord = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-tool/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const dieToolService = {
    getDieToolList,
    getDieToolListByDieId,
    getToolListByProfileId,
    getDieArchiveToolList,
    getDieToolDetails,
    getDieToolById,
    addDieTool,
    updateDieTool,
    deleteDieTool,
    unArchiveDieToolRecord
};

export default dieToolService;
